import request from 'lib/request';

const defaultInspectionsListParams = {
  page: 1,
  pageSize: 5,
  select: [
    'assetId',
    'asset.name',
    'asset.externalId',
    'sourceId',
    'source.name',
    'source.externalId',
    'inspectionType.name',
    'inspector.name',
    'statusOrResult',
    'inspectionDate',
    'finishedAt',
    'isThirdParty',
    'inspectorType',
    'thirdPartyInspectorName',
    'thirdPartyInspectingCompany',
    'workObjectExternalId',
    'workObjectDeadline',
  ],
  relations: [
    'asset',
    'source',
    'locationSource',
    'inspectionType',
    'inspector.profilePhoto',
  ],
};

// Callers name only what they need on top of the defaults: passing select or
// relations outright would drop the fields the shared table renders.
const getInspections = ({
  extraSelect = [],
  extraRelations = [],
  ...params
} = {}) => {
  const { select, relations, ...defaultParams } = defaultInspectionsListParams;

  return request.get('/inspections', {
    params: {
      ...defaultParams,
      select: [...select, ...extraSelect],
      relations: [...relations, ...extraRelations],
      ...params,
    },
  });
};

const defaultWorkObjectListParams = {
  page: 1,
  pageSize: 5,
  select: [
    'id',
    'asset',
    'quantity',
    'source',
    'defaultSource',
    'defaultDestination',
    'defaultSourceExternalId',
    'defaultDestinationExternalId',
    'sourceLocation',
    'destinationLocation',
    'progress',
    'hasMissingInspectionPlan',
    'lastActivity',
    'workObject.externalId',
  ],
  relations: ['assetImg', 'sourceImg'],
};
const getWorkObjects = (params) => {
  return request.get('/work-objects', {
    params: {
      ...defaultWorkObjectListParams,
      ...params,
    },
  });
};

const defaultAssetsListParams = {
  page: 1,
  pageSize: 5,
  select: ['name', 'externalId', 'shortDescription', 'measureTable', 'showId'],
  relations: ['status', 'type', 'images'],
};
const getAssets = (params) => {
  return request.get('/assets', {
    params: {
      ...defaultAssetsListParams,
      ...params,
    },
  });
};

const getMetrics = (params) => {
  return request.get('/dashboard', params);
};

const dashboardService = {
  getInspections,
  getAssets,
  getWorkObjects,
  getMetrics,
};

export default dashboardService;
